export const COMPANIES_FETCH_REQUESTED = 'COMPANIES_FETCH_REQUESTED'
export const COMPANIES_FETCH_SUCCESS = 'COMPANIES_FETCH_SUCCESS'
export const COMPANY_CREATE_REQUESTED = 'COMPANY_CREATE_REQUESTED'
export const COMPANY_CREATE_SUCCESS = 'COMPANY_CREATE_SUCCESS'
export const COMPANY_UPDATE_REQUESTED = 'COMPANY_UPDATE_REQUESTED'
